import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { IPaginator } from '../../interfaces/paginator.interface';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { PaginationStateService } from '../../services/pagination-state.service';
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() paginationFilter!: IPaginator;
  @Input() enableStateStorage = false; // Enable pagination state preservation
  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() rowsChanged: EventEmitter<number> = new EventEmitter();

  currentPage: number;
  maxSize = 7;
  rows = 6;

  constructor(
    private router: Router,
    private paginationStateService: PaginationStateService,
  ) {}

  ngOnInit() {
    if (this.enableStateStorage) {
      // Load saved state
      const savedState = this.paginationStateService.getState(
        this.getCurrentRoute(),
      );
      this.currentPage = savedState.pageNumber;
      this.rows = savedState.pageSize;

      // Emit the loaded state to parent component if different from current
      if (savedState.pageNumber !== this.paginationFilter?.pageNumber) {
        this.pageChange.emit(savedState.pageNumber);
      }
      if (savedState.pageSize !== this.paginationFilter?.pageSize) {
        this.rowsChanged.emit(savedState.pageSize);
      }
    } else {
      this.currentPage = this.paginationFilter.pageNumber;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['paginationFilter'] &&
      changes['paginationFilter']?.currentValue?.pageNumber !==
        changes['paginationFilter']?.previousValue?.pageNumber
    ) {
      this.paginationFilter = { ...changes['paginationFilter'].currentValue };

      // Don't reset currentPage if state preservation is enabled
      if (!this.enableStateStorage) {
        this.currentPage = 0;
      }
    }
  }

  changeRow() {
    this.rowsChanged.emit(this.rows);

    // Save state if enabled
    if (this.enableStateStorage) {
      const currentRoute = this.getCurrentRoute();
      this.paginationStateService.saveState(
        currentRoute,
        this.currentPage,
        this.rows,
      );
    }
  }

  pageChanged(page: PageChangedEvent) {
    this.pageChange.emit(page.page);
    this.currentPage = page.page;

    // Save state if enabled
    if (this.enableStateStorage) {
      const currentRoute = this.getCurrentRoute();

      this.paginationStateService.saveState(
        currentRoute,
        this.currentPage,
        this.rows,
      );
    }
  }

  /**
   * Get current route path, handling both base routes and parameterized routes
   */
  private getCurrentRoute(): string {
    const url = this.router.url;
    // Remove query parameters and get base path
    const basePath = url.split('?')[0];
    // For parameterized routes like /templates/123, get the base route /templates
    const pathSegments = basePath.split('/');

    // Handle common routing patterns
    if (pathSegments.length >= 2) {
      // For routes like /templates/123 or /campaigns/456, return /templates or /campaigns
      return `/${pathSegments[1]}`;
    }

    return basePath;
  }
}
